var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "height": "auto",
      "width": "80%",
      "showClose": false,
      "closeModel": false
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "head-img",
    on: {
      "click": _vm.cancelFn
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/airdrop-tap-icon5.png`),
      "alt": "",
      "height": "100"
    }
  })]), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title) + " ")]), _c('div', {
    staticClass: "pop__intro"
  }, [_vm.$parent.userReward?.total_keys ? [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "alt": "",
      "height": "30"
    }
  }), _vm._v(" " + _vm._s(_vm.$parent.userReward?.total_keys || 0) + "   +   ")] : _vm._e(), _vm.$parent.userReward?.total_taps ? [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/tap.png`),
      "alt": "",
      "width": "30"
    }
  }), _vm._v(" " + _vm._s(_vm.$parent.userReward?.total_taps || 0) + " ")] : _vm._e()], 2), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-confirm",
    style: {
      background: _vm.themeMainColor(_vm.theme).main
    },
    on: {
      "click": _vm.confirmFn
    }
  }, [_vm._v(_vm._s(_vm.$lang("Get Reward")))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };